import { Component } from '@angular/core';
import {IconComponent} from "../../../../elements/icon/icon.component";
import {Icons} from "../../../../../model/icon";

@Component({
  selector: 'app-title-page',
    imports: [
        IconComponent
    ],
  templateUrl: './title-page.component.html',
  styleUrl: './title-page.component.scss'
})
export class TitlePageComponent {

  get newImg() {
    return `app/assets/new/remember-logo-full.png`;
  }

  protected readonly Icons = Icons;
}
